import types from '../../types';

export const showToast = (payload) => ({
  type: types.toast.SHOW_TOAST,
  payload: {
    message: payload.message,
    time: payload.time,
  },
});

export const hideToast = (payload) => ({
  type: types.toast.HIDE_TOAST,
  payload: {
    id: payload.id,
  },
});
